module.exports = __webpack_public_path__ + "media/angular-engine/app/account/funnels/groups/empty-a4422027fb7ffc23a224aeb5e5814f2e.png";